import { render, staticRenderFns } from "./image-tooltip.vue?vue&type=template&id=70ba5bdc&scoped=true&"
import script from "./image-tooltip.vue?vue&type=script&lang=js&"
export * from "./image-tooltip.vue?vue&type=script&lang=js&"
import style0 from "./image-tooltip.vue?vue&type=style&index=0&id=70ba5bdc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70ba5bdc",
  null
  
)

export default component.exports